<template>
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M19.25 4.58333C19.25 3.57225 18.4278 2.75 17.4167 2.75H4.58333C3.57225 2.75 2.75 3.57225 2.75 4.58333V17.4167C2.75 18.4278 3.57225 19.25 4.58333 19.25H17.4167C18.4278 19.25 19.25 18.4278 19.25 17.4167V4.58333ZM4.58333 17.4167V4.58333H17.4167L17.4185 17.4167H4.58333Z"
            fill="currentColor" fill-opacity="0.9" />
        <path
            d="M6.41699 6.41699H8.24849V8.25033H6.41699V6.41699ZM10.0837 6.41699H15.5837V8.25033H10.0837V6.41699ZM6.41699 10.0837H8.24849V11.917H6.41699V10.0837ZM10.0837 10.0837H15.5837V11.917H10.0837V10.0837ZM6.41699 13.7503H8.24849V15.5837H6.41699V13.7503ZM10.0837 13.7503H15.5837V15.5837H10.0837V13.7503Z"
            fill="currentColor" fill-opacity="0.9" />
    </svg>

</template>